<div class="row border-bottom mb-2">
    <!-- <div class="col border-right mb-2">
        <a (click)="toggleNotifications()">
        <ng-container *ngIf="notificationtoggle">
            <p class="mb-0 lh-25 align-middle text-center font-weight-bold">Notifcations</p>
        </ng-container>
        <ng-container *ngIf="!notificationtoggle">
            <p class="mb-0 lh-25 align-middle text-center">Notifcations</p>
        </ng-container>
        </a>
    </div> -->
    <!-- <div class="col border-right mb-2">
        <a (click)="toggleRole()">
            <ng-container *ngIf="roletoggle">
                <p class="mb-0 lh-25 align-middle text-center font-weight-bold">Roles</p>
            </ng-container>
            <ng-container *ngIf="!roletoggle">
                <p class="mb-0 lh-25 align-middle text-center">Roles</p>
            </ng-container>
            </a>    </div> -->
  </div>
  <ng-container *ngIf="notificationtoggle">
    <app-projectnotification></app-projectnotification>
  </ng-container>
  <!-- <ng-container *ngIf="roletoggle">
<p>List template roles here</p>
  </ng-container> -->
